// extracted by mini-css-extract-plugin
export var activityContainer = "_ej-0";
export var typingIndicatorContainer = "_ej-1";
export var typingIndicatorDot = "_ej-2";
export var wave = "_ej-3";